import { action, observable, computed, makeObservable } from "mobx";
import { VehicleRecall } from "./RecallModels";

export default class VehicleRecallModel {
  constructor() {
    makeObservable(this);
  }
  @observable response: VehicleRecall;
  @observable isRecallExist: boolean = false;
  @observable isRequestError: boolean = false;
  @observable RequestErrorStatusCode: string;

  @action reset = () => {
    this.response = null;
    this.isRecallExist = false;
    this.isRequestError = false;
    this.RequestErrorStatusCode = "";
  };
}
